// Frame titles for the 4-panel JTBD narrative
export const FRAME_TITLES = ['The Situation', 'The Struggle', 'The Solution', 'The Outcome']
